import React, { Component, Fragment, createRef } from 'react';
import Pagination from './Pagination';
import Spinner from './Spinner';

import { ITEMS_PER_PAGE } from '../api';
import { getTermFromId, parseStatusFlags, losAngelesToUCLA } from '../utils';

import he from 'he';

class Results extends Component {
  constructor(props) {
    super(props);

    this.loadingRef = createRef();
    this.firstResultsRef = createRef();
  }
  componentDidMount() {
    // if this is the first time we mount the results table then we know we are in a loading state
    if (this.loadingRef.current) {
      this.loadingRef.current.focus();
    }
  }

  componentDidUpdate(prevProps) {
    const startedLoading = !prevProps.isSearching && this.props.isSearching;
    const recievedNewResults = prevProps.results !== this.props.results;

    if (startedLoading && this.loadingRef.current) {
      this.loadingRef.current.focus();
    } else if (recievedNewResults && this.firstResultsRef.current) {
      this.firstResultsRef.current.focus();
    }
  }

  render() {
    const {
      results,
      pageInfo,
      searchFunction,
      isSearching,
      applicantLevel,
      years,
      hasResults
    } = this.props;
    const firstItemNumber = results.length ? (pageInfo.currentPage - 1) * ITEMS_PER_PAGE + 1 : 0;
    const lastItemNuber = results.length ? firstItemNumber + Math.max(0, (results.length - 1)) : 0;

    const parsedSearchResults = results.map(result => ({
      categoryName: result.categoryName,
      campus: losAngelesToUCLA(result.campusName),
      term: getTermFromId(years, result.yearId, result.termId),
      status: parseStatusFlags(result.majorFlags, applicantLevel.id) ? 'Open' : 'Closed',
      majorName: he.decode(result.majorName),
      majorEmphasis: he.decode(result.majorEmphasis)
    }));

    return (
      <div className="search-results">
        <div className="pb-sm-5">
          <div className="section-major-search-results">
            <h3 ref={this.firstResultsRef} tabIndex="-1" className="h4 res-title">{`${applicantLevel.name ? applicantLevel.name : ''} results`}</h3>
            {
              (!isSearching && pageInfo.totalUnlockYear) ? (
                <p className="res-lock-note">The information below is currently being updated.<br/>
                  Please check the admissions application for the most up-to-date majors information.</p>
              ) : null
            }
            <span className="body-3 res-number-results" aria-live={(!isSearching && hasResults) ? "polite" : "off"} tabIndex="-1" ref={this.loadingRef}>
              {
                isSearching ?
                <Fragment>Loading results: <Spinner /></Fragment>
                :
                hasResults && `Showing results ${firstItemNumber} to ${lastItemNuber} of ${pageInfo.totalResultsCount}`
              }
            </span>
            <hr className="hr-1 bg-gray-300 mb-1"/>
            <div className={`table-card ${isSearching ? 'searching' : ''}`}>
              <table id="search-results" className="table table-headers">
                <thead>
                  <tr>
                    <th scope="col" className="">Major</th>
                    <th scope="col" className="">Campus</th>
                    <th scope="col" className="">Term</th>
                    <th scope="col" className="">Category</th>
                    <th scope="col" className="">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    parsedSearchResults.map((result, idx) => (
                      <tr key={idx} id={`search-results-tr-${idx + 1}`} className="">
                        <td id={`search-results-tr-${idx + 1}-td-1`} data-th="Major" className="td-1">
                          {result.majorName}
                          {result.majorEmphasis && <Fragment><br/>{result.majorEmphasis}</Fragment>}
                        </td>
                        <td id={`search-results-tr-${idx + 1}-td-2`} data-th="Campus" className="td-2">{result.campus}</td>
                        <td id={`search-results-tr-${idx + 1}-td-3`} data-th="Term" className="td-3">{result.term}</td>
                        <td id={`search-results-tr-${idx + 1}-td-4`} data-th="Category" className="td-4">{result.categoryName}</td>
                        <td id={`search-results-tr-${idx + 1}-td-5`} data-th="Status" className="td-6">{result.status}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
              {
                !parsedSearchResults.length &&
                  <p className="no-results-text">
                    <b>No results matched your search.</b>
                    <br />
                    Try checking the major name spelling or clicking on the “Show closed majors” checkbox in case the major is closed.
                  </p>
              }
            </div>
            <div className={`pages ${isSearching ? 'searching' : ''}`}>
              <Pagination
                hasResults={hasResults}
                pageInfo={pageInfo}
                searchFunction={searchFunction}
                disabled={isSearching}
              />
            </div>
          </div>
        </div>
      </div>
    )

  }
}

export default Results;
